var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.7 68.4C135.7 105.7 105.4 135.9 68.2 135.9C30.9 135.9 0.700012 105.7 0.700012 68.4C0.700012 31.2 30.9 0.899963 68.2 0.899963C105.4 0.899963 135.7 31.2 135.7 68.4Z",
    fill: "url(#paint0_linear_203_2263)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.2 67.1C113.2 90.7 93.9 109.9 70.3 109.9C63.2 109.9 56.1 108.1 49.9 104.7L27.2 110.6L33.2 88.5C29.5 82 27.5 74.6 27.5 67.1C27.5 43.5 46.7 24.3 70.3 24.3C81.8 24.3 92.6 28.7 100.6 36.8C108.7 44.9 113.2 55.7 113.2 67.1V67.1ZM105.9 67.1C105.9 57.6 102.2 48.6 95.5 41.9C88.8 35.2 79.9 31.5 70.4 31.5C50.7 31.5 34.8 47.4 34.8 67.1C34.8 73.8 36.6 80.3 40.2 86L41 87.3L37.4 100.5L50.9 96.9L52.2 97.7C57.7 100.9 63.9 102.7 70.3 102.7C90 102.7 105.9 86.7 105.9 67.1V67.1ZM91.9 77.3C92.2 77.7 92.2 79.9 91.3 82.4C90.4 84.9 86.1 87.1 84.1 87.4C82.2 87.7 79.9 87.8 77.3 87C75.8 86.5 73.8 85.9 71.2 84.8C60.5 80.1 53.5 69.3 53 68.6C52.4 67.9 48.6 62.8 48.6 57.5C48.6 52.3 51.4 49.7 52.3 48.6C53.3 47.6 54.5 47.3 55.2 47.3C55.9 47.3 56.6 47.3 57.2 47.3C57.9 47.4 58.8 47.1 59.6 49.2C60.5 51.3 62.7 56.6 62.9 57.1C63.2 57.6 63.4 58.3 63 59C62.7 59.7 62.5 60.1 62 60.8C61.4 61.4 60.8 62.2 60.4 62.6C59.8 63.2 59.3 63.7 59.9 64.8C60.5 65.9 62.7 69.4 65.8 72.2C69.9 75.9 73.4 77 74.4 77.5C75.5 78.1 76.1 78 76.8 77.3C77.4 76.6 79.4 74.1 80.1 73.1C80.9 72 81.6 72.2 82.6 72.5C83.5 72.9 88.8 75.5 89.9 76C90.9 76.6 91.7 76.8 91.9 77.3V77.3Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_2263",
    x1: -1.29998,
    y1: 126.1,
    x2: -1.29998,
    y2: -8.90004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78CD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0FC84"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.82e6371fbbde811125cdc3d76ac7114a.svg";
export { ForwardRef as ReactComponent };